import { render, staticRenderFns } from "./markwarrantcollected.vue?vue&type=template&id=80bbc740"
import script from "./markwarrantcollected.vue?vue&type=script&lang=js"
export * from "./markwarrantcollected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports